require([
    'root/Base/Js/Vendor/PictureFill',
    'root/Assets/Js/Templates',
    'jquery'
], function() {
    'use strict';


    $(document).on('click', '.js_readmore',function(){
        var fromHtml = $(this).find('.button--readmore').html();
        var other = $(this).find('.button--readmore').attr('data-textother');


        if ($(this).hasClass('is_open')) {
            $(this).removeClass('is_open');
            $(this).find('.text--readmore').removeClass('maxHeight');
            $(this).find('.text--readmore').html()
        } else {
            $(this).addClass('is_open');
            $(this).find('.text--readmore').addClass('maxHeight');
        }
            $(this).find('.button--readmore').html(other);
            $(this).find('.button--readmore').attr('data-textother', fromHtml);
    })


});
define("root/Assets/Templates/Container/Textelement/Js/Textelement", function(){});

